export const STORE_KEY = '$breadcrumbs'

export const RESET_STORE = 'RESET_STORE'
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS'
